import axios from "@/api/axiosInstance";

export const reactivateEmployee = async (
  employeeUuid: string,
): Promise<void> => {
  await axios.post(`/api/private/employees/${employeeUuid}/reactivate`);
};
